import { render, staticRenderFns } from "./BlockDetailPayment.vue?vue&type=template&id=5b57e2e2&scoped=true&"
import script from "./BlockDetailPayment.vue?vue&type=script&lang=js&"
export * from "./BlockDetailPayment.vue?vue&type=script&lang=js&"
import style0 from "./BlockDetailPayment.vue?vue&type=style&index=0&id=5b57e2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b57e2e2",
  null
  
)

export default component.exports